module.exports = __webpack_public_path__ + "img/weeklyReport_02.9e173802.png";